import { caES, enUS, esES, ptBR, ptPT } from '@mui/material/locale'

const LanguageCodes = {
  'en-US': 'en-US',
  'ca-ES': 'ca-ES',
  'es-ES': 'es-ES',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
}

/**
 * This will be only used on the scope of the i18next module,
 * for other purposes we have Languages Constant
 */
const SupportedLngCodesList = Object.values(LanguageCodes)

const FallbackLanguageCode = LanguageCodes['en-US']

const MuiLocales = {
  [LanguageCodes['ca-ES']]: caES,
  [LanguageCodes['es-ES']]: esES,
  [LanguageCodes['en-US']]: enUS,
  [LanguageCodes['pt-BR']]: ptBR,
  [LanguageCodes['pt-PT']]: ptPT,
}

export { LanguageCodes }
export { FallbackLanguageCode }
export { MuiLocales }
export { SupportedLngCodesList }
